import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-usd-cashin-form',
  templateUrl: './usd-cashin-form.component.html',
  styleUrl: '../../add-cashin.component.scss',
  // Mantiene la fila del formulario como hija visual directa del layout padre.
  styles: [':host { display: contents; }'],
})
export class UsdCashinFormComponent implements OnInit {
  @Input() ctx!: any;

  readonly fusePayoutPurposeOptions = [
    'charity',
    'commercial_investment',
    'corporate_card',
    'credit_card',
    'dividend',
    'family',
    'financial_services',
    'goods_sold',
    'goods_bought',
    'government',
    'insurance',
    'intergroup_transfer',
    'intra_group_dividends',
    'information_technology',
    'leasing',
    'loan_charges',
    'merchant_settlement',
    'mobile_wallet',
    'non_resident_transfer_between_accounts',
    'none',
    'pension',
    'personal_expenses',
    'prepaid_cards',
    'professional',
    'rental',
    'resident_transfer_between_accounts',
    'salaries',
    'telecommunications',
    'travel',
    'utility_bill',
  ].map((value) => ({ value, label: value }));

  readonly railOptions = [
    { label: 'IBAN', value: 'iban' },
    { label: 'Wire (cuenta + routing)', value: 'wire' },
  ];

  ngOnInit(): void {
    this.ctx.declarationCashinForm.patchValue({
      purpose: this.ctx.declarationCashinForm.controls.purpose.value || 'salaries',
      beneficiary_type:
        this.ctx.declarationCashinForm.controls.beneficiary_type.value ||
        'individual',
      rail: this.ctx.declarationCashinForm.controls.rail.value || 'iban',
    });
  }

  setBeneficiaryType(type: 'individual' | 'corporate'): void {
    this.ctx.declarationCashinForm.controls.beneficiary_type.setValue(type);
  }

  get selectedRail(): string {
    return this.ctx.declarationCashinForm.controls.rail.value ?? 'iban';
  }
}
